<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Импорт карт</h2>
          <div class="px-3"></div>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card tile flat>
          <v-card-text>
            <v-textarea v-model="icards" label="вставьте паспорта сюда">
            </v-textarea>
            <v-btn
              color="primary"
              :disabled="cards.length === 0 || cards.length > 10000"
              @click="importCards"
            >
              Загрузить {{ cards.length }} карт
            </v-btn>
            <v-chip v-if="cards.length > 10000" color="warning darken-1" text-color="white" class="py-1 px-3 ml-3">
              <v-avatar>
                <v-icon>warning</v-icon>
              </v-avatar>
              Слишком много карт за раз (максимум 10000)
            </v-chip>
            <h3 v-if="imported && imported.length">Загружено: {{imported.length}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Cards',
  data: () => ({
    icards: '',
    imported: [],
  }),
  methods: {
    async importCards () {
      try {
        const { cards, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'import-cards',
          pl: { cards: this.cards }
        })
        this.imported = cards
        this.$store.dispatch('snack', meta)
        this.icards = ''
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    cards () {
      return this.icards
      .split('\r')
      .join('')
      .split('\n')
      .filter(x => x.includes(';'))
      .map(x => {
        const vals = x.split(';')
        return { cardid: ('000' + vals[0]).slice(-9), code: vals[1].slice(0, 10) }
      })
    }
  },
  watch: {
    async profile (val) {
    }
  },
  mounted () {
  }
}
</script>

<style>
</style>
